import React, { lazy, Suspense } from "react";

const Wrapper = lazy(() => import("./Wrapper"));

export default function LoadableCustomUpdate() {
  return (
    <Suspense fallback={"Loading"}>
      <Wrapper />
    </Suspense>
  );
}
